import { z } from 'zod/v4-mini';

import { Schema } from '@/utils/zodUtils.ts';

export type Phone = {
  number: string;
  description: string;
};

export const phoneSchema: Schema<Phone> = z.object({
  number: z.string(),
  description: z.string(),
});

export const multiplePhoneSchema: Schema<Phone | undefined> = z.pipe(
  z.array(phoneSchema),
  z.transform(phones =>
    phones.length > 0 && phones[0] ? phones[0] : undefined,
  ),
);

export const flatPhoneSchema: Schema<string | undefined> = z.pipe(
  multiplePhoneSchema,
  z.transform(phone => phone?.number),
);
